<template>
	<div>
		<router-link :to="`/Member/Authorization`" style="text-decoration: none;" v-if="type === 'headerdrawer'">
			<div class="pointer">
				<v-badge :color="color" :content="title" inline>
				</v-badge>
			</div>
		</router-link>
		<div @click="showManager()" class="pointer" v-else-if="type === 'badge'">
			<v-badge :color="color" :content="title" inline>
			</v-badge>
		</div>
		<div v-else-if="type === 'detail'">
			<v-card class="rounded-xl" elevation="2">
				<v-card-title class="d-flex align-center">
					<v-avatar class="ml-3" size="40" :color="isAuthorized ? 'green lighten-5' : 'orange lighten-5'">
						<v-icon :color="isAuthorized ? 'green' : 'orange'">
							{{ isAuthorized ? 'mdi-check' : 'mdi-history' }}
						</v-icon>
					</v-avatar>
					<div class="d-flex flex-column">
						<div class="text-subtitle-1 font-weight-bold d-flex" :class="isAuthorized ? 'green--text' : 'orange--text'">
							{{ title }}
						</div>
						<!-- <div class="grey--text">
							دفعات استعلام: <strong>{{ (group.items || []).length }}</strong>
						</div> -->
					</div>
					<v-spacer />
					<v-btn small :color="isAuthorized ? 'success' : 'orange'" class="rounded-lg" @click="showManager()">
						<v-icon left small>mdi-credit-card-lock</v-icon>
						{{ isAuthorized ? 'مشاهده گام های احراز شده' : 'تکمیل گام های احراز هویت' }}
					</v-btn>
				</v-card-title>
				<v-divider />
				<v-card-text class="pa-0">
					<v-alert v-if="!localItems.length && isDetailExpanded" type="warning" icon="mdi-information-outline" outlined class="ma-2">
						گام احراز هویتی یافت نشد.
					</v-alert>
					<div v-show="localItems.length && isDetailExpanded">
						<div class="d-flex pa-2 align-center" v-for="(item, idx) in localItems" :key="idx" style="border-bottom: 1px dashed #eee;">
							<v-avatar class="ml-3" size="30" :color="item.status === 20 ? 'green lighten-5' : 'grey lighten-5'">
								<v-icon :color="item.status === 20 ? 'green' : 'grey'">
									{{ item.status === 20 ? 'mdi-check' : 'mdi-history' }}
								</v-icon>
							</v-avatar>
							<span class="ml-2" :class="item.status === 20 ? 'green--text' : 'grey--text'">{{ item.authorizationItem ? item.authorizationItem.title : '' }}</span>
						</div>
					</div>
					<div class="pa-3 text-center">
						<v-btn text small color="primary" @click="isDetailExpanded = !isDetailExpanded" class="rounded-lg">
							<v-icon left small>
								{{ isDetailExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
							</v-icon>
							{{ isDetailExpanded ? 'بستن جزئیات' : 'مشاهده جزئیات' }}
						</v-btn>
					</div>
				</v-card-text>
			</v-card>
		</div>

		<v-dialog v-model="managerDialog" scrollable max-width="800px">
			<v-card class="pa-2" v-if="managerDialog">
				<v-card-title>
					<div>
						<span class="headline">گام های احراز هویت</span>
						{{ '(' }}
						<label class="ml-1">نام مشتری:</label>&nbsp;
						<label class="secondary--text">{{ member.fullName }}</label>&nbsp;
						<label class="ml-1 mr-5">کد ملی:</label>&nbsp;
						<label class="secondary--text">{{ member.nationalCode }}</label>
						{{ ')' }}
					</div>
					<v-spacer />
					<v-btn @click="managerDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pt-3">
					<v-alert v-if="!checkActivePart('memberAuthorization')" type="error" outlined>ماژول احراز هویت برای
						شما فعال نمی باشد.</v-alert>
					<div v-else>
						<div v-if="loading">
							<v-progress-linear class="mt-3" color="primary" height="4" indeterminate rounded></v-progress-linear>
							<v-alert type="warning" icon="mdi-timer-sand" outlined>
								در حال دریافت اطلاعات...
							</v-alert>
						</div>
						<div v-else>
							<h3 class="text-center red--text mb-5" v-if="!localItems.length">گامی جهت احراز هویت در
								دسترس نمی باشد.</h3>
							<div class="text-center ">
								<div>
									<v-btn color="secondary" small v-if="area === 'admin'" @click="showBusinessItems()">
										مدیریت گام های لازم جهت احراز هویت
									</v-btn>
								</div>
								<div>
									<div class="info--text pa-3" type="info" outlined v-if="localItems.length && area !== 'admin'">
										کاربر گرامی؛ پس از آماده سازی هر گام، دکمه ثبت مرتبط با آن را بزنید.
									</div>
									<v-row class="mt-1 justify-center">
										<v-col cols="12" sm="12" md="12" class="px-5" v-for="(auth, index) in localItems" :key="auth.id + index">
											<v-card class="mb-4" elevation="4">
												<div class="text-center text-h4 white--text pa-2 grey" style="border-top-left-radius: 10px; border-top-right-radius: 10px">
													{{ auth.authorizationItem.title }}
												</div>
												<div class="px-3">
													<div class="text-center mb-2 pa-2" style="border-bottom: 1px dashed #ddd;white-space: pre-line;" v-if="auth.authorizationItem.description && ![5, 6].includes(auth.authorizationItem.systemType)" v-html="replaceToLink(auth.authorizationItem.description)">

													</div>
													<v-row class="mt-0">
														<v-col ols="12" md="9" class="text-center" style="border-left: 1px dashed #ccc;">
															<IceManager v-if="auth.authorizationItem.systemType === 1" :isAdmin="false" :isSummery="true" />

															<IranValidityManager v-else-if="auth.authorizationItem.systemType === 2" :isAdmin="false" :isSummery="true" />

															<MobileVerification v-else-if="auth.authorizationItem.systemType === 12" :member="member" :area="area" :memberAuthorizationItem="auth" />

															<MemberInquiry v-else-if="[15, 16, 17, 18, 19].includes(auth.authorizationItem.systemType)" :area="area" :type="converSystemTypeToType(auth.authorizationItem.systemType)" :memberAuthorizationItem="auth" :memberId="member.id" />

															<div v-if="auth.authorizationItem.systemType === 0">
																<v-row v-for="(attachment, index) in auth.attachments.filter(x => x.rowState !== 'deleted')" :key="attachment.id + index" style="">
																	<v-col cols="12" md="3" class="pb-3">
																		<ImageUploader style="width: 100px;" :ref="'imageUploader' + auth.id + index" :editable="checkIsEditable(auth.status)" v-model="attachment.base64" :fileUrl="attachment.fileUrl" :errorImage="require('@/assets/no-image.png')" @delete="() => attachment.attachment = ''" />
																	</v-col>
																	<v-col cols="12" md="9">
																		<div class="text-right" v-if="!checkIsEditable(auth.status)">
																			<div>توضیحات:</div>
																			<div class="grey--text" style="white-space: pre-line">
																				{{ attachment.memberDescription }}
																			</div>
																		</div>
																		<div v-else>
																			<v-text-field v-model="attachment.memberDescription" label="توضیحات خود را در صورت لزوم اینجا وارد کنید" :error-messages="errorMessages" :rules="[(val) => !val || val.length < 1000 || 'حداکثر 1000 کاراکتر']" />
																		</div>
																	</v-col>
																</v-row>
															</div>

															<v-row v-if="area === 'admin'" class="mt-2">
																<v-col cols="12" class="text-right">
																	تغییر وضعیت:
																	<v-btn-toggle dense class="my-2" v-model="auth.status" tile outlined color="deep-purple accent-3">
																		<v-btn :value="0">
																			منتظر کاربر
																		</v-btn>
																		<v-btn :value="5">
																			ثبت شده توسط کاربر
																		</v-btn>
																		<v-btn :value="10">
																			منتظر کارشناس
																		</v-btn>
																		<v-btn :value="15">
																			ناقص
																		</v-btn>
																		<v-btn :value="20">
																			تایید شده توسط مدیر
																		</v-btn>
																	</v-btn-toggle>
																	<div class="d-flex" v-if="area === 'admin'">
																		<span class="pt-2 pl-1">
																			نظر کارشــناس:
																		</span>
																		<v-text-field dense v-model="auth.adminDescription" outlined :error-messages="errorMessages" />
																	</div>
																	<div v-else-if="auth.adminDescription" class="red--text">
																		نظر کارشناس:
																		<div style="white-space: pre-line">
																			{{ auth.adminDescription }}
																		</div>
																	</div>
																</v-col>
															</v-row>

														</v-col>
														<v-col cols="12" md="3" class="py-0 d-flex justify-center align-center flex-column">
															<v-btn class="mb-3" :loading="submitAuthorizeItemLoading === auth.id + index" prepend-icon="mdi-check" @click="submitAuthorizeItem(auth, index)" v-if="checkIsEditable(auth.status)" color="secondary" small dark>
																<template v-slot:prepend>
																	<v-icon color="success" small>mdi-check</v-icon>
																</template>
																ثبت
															</v-btn>
															<v-badge :color="auth.status === 20 ? 'success' : 'grey'" :content="auth.status_Text" inline v-if="area !== 'admin'">
															</v-badge>
														</v-col>
													</v-row>
												</div>
											</v-card>
										</v-col>
									</v-row>
								</div>
							</div>
						</div>
					</div>
				</v-card-text>
				<confirm-dlg ref="confirm" />
			</v-card>
		</v-dialog>

		<v-dialog v-model="authorizationItemsDialog" scrollable max-width="1000px">
			<AuthorizationItems @select="addSelection" v-if="authorizationItemsDialog" @close="authorizationItemsDialog = false" />
		</v-dialog>

		<v-dialog v-model="businessDialog" max-width="500px">
			<v-card class="pa-2">
				<v-card-title>
					<div>
						<span class="headline">گام های مورد نیاز احراز هویت</span>
					</div>
					<v-spacer />
					<v-btn @click="businessDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pt-3">
					<div v-if="!businessAuthorizations.length">
						<h3 class="text-center red--text">گامی برای احراز هویت ثبت نشده است.</h3>
						<div class="text-center mt-5">
							<v-btn class="mx-auto" color="secondary" dark @click="authorizationItemsDialog = true">
								<v-icon dark>
									mdi-plus-circle-outline
								</v-icon>
								افزودن گام
							</v-btn>
						</div>
					</div>
					<div v-else>
						<v-card v-for="(item, index) in businessAuthorizations" :key="item.id + index" class="mb-3 pa-3" elevation="0" style="border: 1px solid #dca6e5">
							<v-card-text class="mb-2">
								<v-row class="d-flex">
									<v-col cols="12" md="11" class="py-0 my-0">
										<div class="text-h4">{{ item.authorizationItem.title }}</div>
										<div class="text-h6 grey--text">
											<span>{{ getSystemType(item.authorizationItem.systemType) }}</span>
										</div>
										<div class="mt-3">
											<v-text-money dense v-model="item.cost" hide-details label="هزینه (تومان)" outlined :error-messages="errorMessages" style="width: 150px;" />
										</div>
									</v-col>
									<v-col cols="12" md="1" class="my-0 py-0 d-flex align-center flex-column justify-center">
										<v-btn @click="removeBusiness(item, index)" :loading="loading" class="" small icon color="red" dark title="حذف">
											<v-icon>
												mdi-trash-can-outline
											</v-icon>
										</v-btn>
										<v-btn @click="updateBusiness(item)" :loading="loading" class="" small icon color="secondary" dark title="آپدیت">
											<v-icon>
												mdi-content-save-outline
											</v-icon>
										</v-btn>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
						<div class="text-center mt-5">
							<v-btn class="mx-auto" color="secondary" dark @click="authorizationItemsDialog = true">
								<v-icon dark>
									mdi-plus-circle-outline
								</v-icon>
								افزودن مدرک
							</v-btn>
						</div>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="notValidItemSelectedDialog" max-width="450px" scrollable>
			<v-card>
				<v-card-title>
					<div>
						<span class="headline">توجه</span>
					</div>
					<v-spacer />
					<v-btn @click="notValidItemSelectedDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<div class="text-justify red--text pa-5">
						آیتم با نوع سیستمی "احراز هویت" مجاز به انتخاب نمی باشد.
					</div>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer />
					<v-btn color="primary" @click="notValidItemSelectedDialog = false">
						متوجه شدم
					</v-btn>
					<v-spacer />
				</v-card-actions>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
	import api from '@/util/app-api'
	import { get, call } from 'vuex-pathify'
	import toast from '@/util/toast'
	import { emptyId } from '@/util/emptyId'
	import { cloneDeep } from 'lodash'
	import { authorizationSystemTypes } from '@/util/enums'
	import { base_inquiries } from '@/plugins/inquiries.js'

	export default {
		name: 'MemberAuthorizationManager',
		props: {
			member: { type: Object, default: null },
			items: { type: Array, default: null },
			area: { type: String, default: null },
			type: { type: String, default: 'badge' },
			filterId: { type: String, default: '' },
			defaultDetailExpanded: { type: Boolean, default: false }
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			AuthorizationItems: () => import('@/components/forms/AuthorizationItems.vue'),
			MobileVerification: () => import('@/components/memberAuthorization/MobileVerification.vue'),
			MemberInquiry: () => import('@/components/memberAuthorization/MemberInquiry.vue'),
		},
		data() {
			return {
				loading: false,
				managerDialog: false,
				businessDialog: false,
				authorizationItemsDialog: false,
				notValidItemSelectedDialog: false,
				localItems: [],
				systemTypes: authorizationSystemTypes,
				errorMessages: '',
				submitAuthorizeItemLoading: false,
				isDetailExpanded: false
			}
		},
		watch: {
			items: {
				immediate: true,
				handler(val, oldVal) {
					this.localItems = val || []
				}
			}
		},
		computed: {
			businessAuthorizations: get('businessAuthorizations/all'),
			isAuthorized() {
				return this.localItems.length && this.localItems.every(i => i.status === 20)
			},
			color() {
				if (this.loading)
					return 'grey'
				return this.isAuthorized ? 'green' : 'orange'
			},
			title() {
				if (this.loading)
					return 'در حال دریافت اطلاعات...'
				return this.isAuthorized ? 'احراز هویت شده' : 'احراز هویت تکمیل نشده'
			}
		},
		mounted() {
			this.isDetailExpanded = this.defaultDetailExpanded
			if (this.items == null) {
				if (this.checkActivePart('memberAuthorization'))
					this.loadData()
			}
			if (this.type === 'managerDialog')
				this.showManager()
		},
		methods: {
			fetchBusinessAuthorizations: call('businessAuthorizations/fetch'),
			loadData() {
				if (!this.member)
					return
				this.loading = true
				api.get('member/MemberAuthorizationItem/SyncAndGetMemberAuthorizationsItems/' + this.member.id)
					.then(
						response => {
							this.localItems = response
						})
					.catch(err => {
						toast.error('خطا در دریافت لیست مدارک. ' + err.message)
					})
					.finally(x => {
						this.loading = false
					})
			},
			update(updatedVal) {

			},
			showManager() {
				this.managerDialog = true
			},
			checkIsEditable(status) {
				return this.area === 'admin' || (status != 10 && status != 20)
			},
			addAttachment(attachments) {
				attachments.push({
					id: emptyId,
					rowState: 'new',
					attachment: '',
					memberDescription: '',
					base64: '',
					attachmentByAdmin: false,
				})
			},
			deleteAttachment(attachments, index) {
				if (index < attachments.length) {
					if (attachments[index].rowState === 'new')
						attachments.splice(index, 1)
					else
						attachments[index].rowState = 'deleted'
				}
			},
			replaceToLink(text) {
				if (!text)
					return ''
				return text.replace(
					/((http|https|ftp|ftps)\:\/\/[a-zA-Z0-9\-\.]+\.[a-zA-Z]{2,3}(\/\S*)?)/g,
					'<a href="$1" target="_blank">$1</a>'
				)
			},
			viewImage(img) {

			},
			submitAuthorizeItem(auth, index) {
				const formData = new FormData()
				for (let i = 0; i < auth.attachments.length; i++) {
					var fileUploader = Array.isArray(this.$refs['imageUploader' + auth.id + i]) ? this.$refs['imageUploader' + auth.id + i][0] : null

					if (fileUploader && fileUploader.hasFile()) {
						formData.append(`Attachments[${i}].File`, fileUploader.getFile())
					}
					else if (!auth.attachments[i].memberDescription && !auth.attachments[i].base64 && auth.authorizationItem.systemType === 0) {
						toast.error(`اطلاعاتی برای ${auth.authorizationItem.title} ثبت نکرده اید.`)
						return
					}
					formData.append(`attachments[${i}][id]`, auth.attachments[i].id)
					formData.append(`attachments[${i}][memberDescription]`, auth.attachments[i].memberDescription)
					formData.append(`attachments[${i}][attachment]`, auth.attachments[i].attachment)
					formData.append(`attachments[${i}][rowState]`, auth.attachments[i].rowState)
				}
				formData.append('id', auth.id)
				if (this.area === 'admin') {
					formData.append('adminDescription', auth.adminDescription)
					formData.append('status', auth.status)
				}
				formData.append('authorizationItem[id]', auth.authorizationItem.id)
				formData.append('authorizationItem[title]', auth.authorizationItem.title)
				formData.append('member[id]', this.member.id)
				this.submitAuthorizeItemLoading = auth.id + index
				api.post(`${this.area === 'admin' ? 'admin' : 'member'}/MemberAuthorizationItem/${auth.id === emptyId ? 'create' : 'edit'}`, formData, { contentType: 'multipart/form-data' })
					.then(response => {
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						if (auth.id === emptyId) {
							auth.id = response.id
						}
						// if (fileUploader && fileUploader.hasFile()) {
						// 	fileUploader.toBase64(fileUploader.getFile()).then(res => {
						// 		auth.base64 = res
						// 	})
						// }
						auth.status_Text = response.status_Text
						auth.status = response.status
						this.$emit('callbck', 'updated')
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.submitAuthorizeItemLoading = '' })
			},
			async removeBusiness(item, index) {
				if (!item) {
					return
				}
				this.loading = true
				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این گام مطمئن هستید؟',
				)) {
					api.post('admin/BusinessAuthorizationItem/delete/' + item.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.fetchBusinessAuthorizations({ force: true })
								this.loadData()
							})
						.catch(err => {
							toast.error(err.message)
						})
						.finally(err => {
							this.loading = false
						})
				}
			},
			updateBusiness(item) {
				if (!item) {
					return
				}
				this.loading = true
				api.post('admin/BusinessAuthorizationItem/Edit/', item)
					.then(
						response => {
							toast.success('اطلاعات با موفقیت ذخیره شد.')
							this.fetchBusinessAuthorizations({ force: true })
							this.loadData()
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(err => {
						this.loading = false
					})
			},
			async addSelection(items) {
				if (items.some(x => x.systemType === 10)) {
					this.notValidItemSelectedDialog = true
					return
				}
				this.authorizationItemsDialog = false
				let itemsToAdd = []
				if (items?.length > 0) {
					itemsToAdd = items.filter(x => !this.businessAuthorizations.some(i => i.authorizationItem.id === x.id))
				}

				if (!itemsToAdd.length)
					return

				this.loading = true
				for (let index = 0; index < itemsToAdd.length; index++) {
					let item = itemsToAdd[index]
					let data = {
						authorizationItem: { id: item.id, title: item.title },
					}
					this.loading = true
					await api.post('admin/BusinessAuthorizationItem/create', data)
						.then(response => {
							toast.success(`گام ${item.title} با موفقیت اضافه شد.`)
							if (item.id === emptyId) {
								item.id = response
							}
						})
						.catch(err => {
							toast.error(err.message)
						})
						.finally(err => {
							this.loading = false
						})
				}
				this.fetchBusinessAuthorizations({ force: true })
				this.loadData()
			},
			getSystemType(type) {
				return this.systemTypes.find(x => x.id === type)?.title || ''
			},
			converSystemTypeToType(systemType) {
				return base_inquiries.find(x => x.systemType === systemType)?.type
			},
			async showBusinessItems() {
				await this.fetchBusinessAuthorizations()
				this.businessDialog = true
			}
		}
	}
</script>
<style scoped></style>
